import { render, staticRenderFns } from "./Emolumentos.vue?vue&type=template&id=13305e4c&scoped=true&"
import script from "./Emolumentos.vue?vue&type=script&lang=js&"
export * from "./Emolumentos.vue?vue&type=script&lang=js&"
import style0 from "./Emolumentos.vue?vue&type=style&index=0&id=13305e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13305e4c",
  null
  
)

export default component.exports